/* @flow */

import VanillaToasts from 'vanillatoasts';

const mensagemSucesso = (text: string) => {
    VanillaToasts.create({
        title: 'Sucesso',
        text,
        type: 'success',
        timeout: 5000,
    });
};

export const mensagemErro = (text: string) => {
    VanillaToasts.create({
        title: 'Algo deu errado.',
        text,
        type: 'danger',
        timeout: 5000,
    });
};

export default mensagemSucesso;
